module.exports = __webpack_public_path__ + "img/swhz-bn1.37d7c34a.png";